"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialMatchFeature = void 0;
class PartialMatchFeature {
    checks;
    constructor(rules) {
        this.checks = [...rules].map(rule => {
            const entries = Object.entries(rule);
            return (candidate) => entries.every(([key, value]) => candidate[key] === value);
        });
    }
    isEnabled(candidate) {
        if (candidate == null)
            return false;
        return this.checks.some(check => check(candidate));
    }
}
exports.PartialMatchFeature = PartialMatchFeature;
